import { TOUR_TRANSLATIONS } from "../translations"

export const getAmazonReleaseDateSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="amazon-release-date-filters"]',
            title: t.amazonReleaseDateFilters.title,
            content: t.amazonReleaseDateFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="amazon-release-date-table"]',
            title: t.amazonReleaseDateTable.title,
            content: t.amazonReleaseDateTable.content,
        },
        {
            target: '[data-tour="amazon-release-date-create-report"]',
            title: t.amazonReleaseDateCreateReport.title,
            content: t.amazonReleaseDateCreateReport.content,
        },
    ]
}
